import * as React from 'react';
import { get } from 'lodash';
import Grid from '@lendi-ui/grid';

import { FIELD_PATHS } from '@funnels/constants';
import { FormValues } from '@funnels/types';

import {
  BuyingSituationReadOnlyView,
  CashoutAmountReadOnlyView,
  ConsolidateDebtAmountReadOnlyView,
  HowCanWeHelpReadOnlyView,
  LenderFeaturesReadOnlyView,
  RefinancingReasonsReadOnlyView,
  RepaymentTypeReadOnlyView,
  UrgencyReadOnlyView,
} from '../../../Questions';
import { PaddedGridUnit } from '../_common/style';

interface ConstructionLoanLayoutProps {
  currentValues: FormValues;
}

export const ConstructionLoanLayout = (props: ConstructionLoanLayoutProps) => {
  const { currentValues } = props;
  return (
    <Grid gutter="nil">
      <PaddedGridUnit size={1}>
        <RefinancingReasonsReadOnlyView
          value={get(currentValues, FIELD_PATHS.APPLICATION_REFINANCING_REASON(0, 0), undefined)}
        />
      </PaddedGridUnit>
      <PaddedGridUnit size={1}>
        <UrgencyReadOnlyView value={get(currentValues, FIELD_PATHS.APPLICATION_URGENCY(0), undefined)} />
      </PaddedGridUnit>
      <PaddedGridUnit size={1}>
        <RepaymentTypeReadOnlyView value={get(currentValues, FIELD_PATHS.APPLICATION_PAYMENT_TYPE(0), undefined)} />
      </PaddedGridUnit>
      <PaddedGridUnit size={1}>
        <LenderFeaturesReadOnlyView
          value={get(currentValues, FIELD_PATHS.APPLICATION_DESIRED_FEATURES(0), undefined)}
        />
      </PaddedGridUnit>
    </Grid>
  );
};

interface NewPurchaseLayoutProps {
  currentValues: FormValues;
}

export const NewPurchaseLayout = (props: NewPurchaseLayoutProps) => {
  const { currentValues } = props;
  return (
    <Grid gutter="nil">
      <PaddedGridUnit size={1}>
        <HowCanWeHelpReadOnlyView value={get(currentValues, FIELD_PATHS.APPLICATION_PRIMARY_PURPOSE(0), undefined)} />
      </PaddedGridUnit>
      <PaddedGridUnit size={1}>
        <BuyingSituationReadOnlyView
          value={get(currentValues, FIELD_PATHS.APPLICATION_PURCHASE_SITUATION(0), undefined)}
        />
      </PaddedGridUnit>
      <PaddedGridUnit size={1}>
        <RepaymentTypeReadOnlyView value={get(currentValues, FIELD_PATHS.APPLICATION_PAYMENT_TYPE(0), undefined)} />
      </PaddedGridUnit>
      <PaddedGridUnit size={1}>
        <LenderFeaturesReadOnlyView
          value={get(currentValues, FIELD_PATHS.APPLICATION_DESIRED_FEATURES(0), undefined)}
        />
      </PaddedGridUnit>
    </Grid>
  );
};

export const PreapprovalLayout = NewPurchaseLayout;

interface RefinanceLayoutProps {
  currentValues: FormValues;
}

export const RefinanceLayout = (props: RefinanceLayoutProps) => {
  const { currentValues } = props;
  return (
    <Grid gutter="nil">
      <PaddedGridUnit size={1}>
        <RefinancingReasonsReadOnlyView
          value={get(currentValues, FIELD_PATHS.APPLICATION_REFINANCING_REASON(0, 0), undefined)}
        />
      </PaddedGridUnit>
      <PaddedGridUnit size={1 / 2}>
        <ConsolidateDebtAmountReadOnlyView
          value={get(currentValues, FIELD_PATHS.APPLICATION_CONSOLIDATE_AMOUNT(0), undefined)}
        />
      </PaddedGridUnit>
      <PaddedGridUnit size={1 / 2}>
        <CashoutAmountReadOnlyView value={get(currentValues, FIELD_PATHS.APPLICATION_CASHOUT_AMOUNT(0), undefined)} />
      </PaddedGridUnit>
      <PaddedGridUnit size={1 / 2}>
        <UrgencyReadOnlyView value={get(currentValues, FIELD_PATHS.APPLICATION_URGENCY(0), undefined)} />
      </PaddedGridUnit>
      <PaddedGridUnit size={1 / 2}>
        <RepaymentTypeReadOnlyView value={get(currentValues, FIELD_PATHS.APPLICATION_PAYMENT_TYPE(0), undefined)} />
      </PaddedGridUnit>
      <PaddedGridUnit size={1}>
        <LenderFeaturesReadOnlyView
          value={get(currentValues, FIELD_PATHS.APPLICATION_DESIRED_FEATURES(0), undefined)}
        />
      </PaddedGridUnit>
    </Grid>
  );
};
